export default __webpack_public_path__ + "static/media/wishlist-filled.53cc3f9f.svg";